var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pricing-card-line pricing-card-line--custom"},[_c('span',{staticClass:"pricing-card-line__item"},[_vm._t("default")],2),_c('span',{staticClass:"pricing-card-line__type mr-1"}),_c('span',{staticClass:"pricing-card-line__value"},[_vm._v(_vm._s(_vm.$t('customPricingLabel')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }